import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: #fff;
  padding: 24px;
  border-radius: 16px;
`;
export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
`;
export const ModalContainer = styled.div`
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-end;
`;
export const Item = styled.div`
  flex-grow: 1;
  flex-basis: auto;
  & .ant-input {
    border-radius: 8px;
    height: 40px;
  }
  & .date-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    & .ant-picker {
      width: 140px;
      background: #e3f0ff;
      border-radius: 10px;
      border: none;
      height: 44px;
    }
  }
  & .d-picker {
    max-width: 250px;
  }
  &:last-child {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;
export const Title = styled.h4`
  color: #28303f;
  font-size: 24px;
  font-weight: 600;
`;

export const Label = styled.span`
  color: #a8a8a8;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 4px;
`;
